/** Civilians and wild things: the trade wagon, the ferry, and the camp monsters. */
export const ART_UNITS_WILD: string[][][] = [
  /* 0 (UNIT_ART 5) Caravan — 16x16. Neutral trade wagon: hooped canvas tilt in
     the owner's colour, crate and gold-banded barrel lashed on top, iron-tyred
     wheels. Frame 1 rocks the whole load forward and turns the spokes. */
  [
    [
      '                ',
      '    bbb  bbb    ',
      '    bqb  byb    ',
      '   #bbb##bbb#   ',
      '   PPPPPPPPPP   ',
      '  PPPPPPPPPPPP  ',
      '  PbPPPPbPPPPb  ',
      '  PbPPPPbPPPPb  ',
      '  pbppppbppppb  ',
      ' bbbbbbbbbbbbbb ',
      ' bwwwwwwwwwwwwb ',
      ' bwqwwqwwqwwqwb ',
      '   ##      ##   ',
      '  #wq#    #wq#  ',
      '  #qw#    #qw#  ',
      '   ##      ##   ',
    ],
    [
      '                ',
      '     bbb  bbb   ',
      '     bqb  byb   ',
      '    #bbb##bbb#  ',
      '    PPPPPPPPPP  ',
      '   PPPPPPPPPPPP ',
      '   PbPPPPbPPPPb ',
      '   PbPPPPbPPPPb ',
      '   pbppppbppppb ',
      ' bbbbbbbbbbbbbb ',
      ' bwwwwwwwwwwwwb ',
      ' bwqwwqwwqwwqwb ',
      '   ##      ##   ',
      '  #qw#    #qw#  ',
      '  #wq#    #wq#  ',
      '   ##      ##   ',
    ],
  ],

  /* 1 (UNIT_ART 6) Transport boat — 20x16. Clinker hull with a raised stem post
     at the bow, a shield strake in the owner's colour along the gunwale, and a
     square sail on a single mast. Frame 1 flips the masthead pennant, reverses
     the billow of the sail and shifts the foam under the keel. */
  [
    [
      '         bPP        ',
      '         b          ',
      '    bbbbbbbbbbbb    ',
      '    PPPPPbPPPPPP    ',
      '    PPPPPbPPPPPP    ',
      '    pPPPPbPPPPPp    ',
      '    PPPPPbPPPPPP    ',
      '    pPPPPbPPPPPp  b ',
      '     PPPPbPPPPP  b  ',
      '   b ppppbppppp b   ',
      '  wwwwwwwbwwwwwwww  ',
      ' bPPbPPbPPbPPbPPb   ',
      ' wwwwwwwwwwwwwwwwww ',
      ' bwwwwwwwwwwwwwwwwb ',
      '  bbwwwwwwwwwwwwbb  ',
      '    cccccccccccc    ',
    ],
    [
      '        PPb         ',
      '         b          ',
      '    bbbbbbbbbbbb    ',
      '    pPPPPbPPPPPp    ',
      '    PPPPPbPPPPPP    ',
      '    PPPPPbPPPPPP    ',
      '    pPPPPbPPPPPp    ',
      '    PPPPPbPPPPPP  b ',
      '     ppppbppppp  b  ',
      '   b PPPPbPPPPP b   ',
      '  wwwwwwwbwwwwwwww  ',
      ' bPPbPPbPPbPPbPPb   ',
      ' wwwwwwwwwwwwwwwwww ',
      ' bwwwwwwwwwwwwwwwwb ',
      '  bbwwwwwwwwwwwwbb  ',
      '   cccccccccccc     ',
    ],
  ],

  /* 2 (UNIT_ART 17) Orc Raider — 16x16. Green hide, war-paint stripes across the
     cheeks, jutting tusks, leather pauldrons and kilt, crude iron cleaver on a
     wooden haft. Bandy-legged and hunched — nothing about him is symmetrical.
     Frame 1 drops the whole body a pixel, swings the cleaver down and throws the
     legs into a wide splayed stride. */
  [
    [
      '                ',
      '            dd  ',
      '    EEEE   dmmd ',
      '   EeeeeE  dmmd ',
      '   ekeeke  dmd  ',
      '   xeeeex  ww   ',
      '   EmeemE  ww   ',
      '  qqEEEEqq ww   ',
      '  qePPPPeq ww   ',
      '  eePPPPee ww   ',
      '  eePPPPeeeww   ',
      '   qPPPPq  ww   ',
      '   qqqqqq       ',
      '   ee  ee       ',
      '   Ee  eE       ',
      '  ###  ###      ',
    ],
    [
      '                ',
      '                ',
      '            dd  ',
      '    EEEE   dmmd ',
      '   EeeeeE  dmmd ',
      '   ekeeke  dmd  ',
      '   xeeeex  ww   ',
      '   EmeemE  ww   ',
      '  qqEEEEqq ww   ',
      '  qePPPPeq ww   ',
      '  eePPPPeeeww   ',
      '   qPPPPq  ww   ',
      '  qqqqqqqq      ',
      '  ee    ee      ',
      '  Ee     eE     ',
      ' ###      ###   ',
    ],
  ],

  /* 3 (UNIT_ART 18) Goblin — 16x16. Small and wiry: half the orc's mass, an
     oversized head with jug ears, a snaggle-toothed grin, a cap and tunic in the
     owner's colour and a shiv held out sideways. Frame 1 crouches him a row
     lower, drops one torso row and scatters the legs into a scurry. */
  [
    [
      '                ',
      '                ',
      '                ',
      '                ',
      '                ',
      '      PPPP      ',
      '  ii PPPPPP ii  ',
      '   iiiiiiiiii   ',
      '    ikiiiiki    ',
      '    IiimmiiI    ',
      '   qiiiiiiiq    ',
      '   iPPPPPPPi    ',
      '   iPPPPPPPiwmm ',
      '   IqqqqqqI     ',
      '    ii  ii      ',
      '   ##   ##      ',
    ],
    [
      '                ',
      '                ',
      '                ',
      '                ',
      '                ',
      '                ',
      '      PPPP      ',
      '  ii PPPPPP ii  ',
      '   iiiiiiiiii   ',
      '    ikiiiiki    ',
      '    IiimmiiI    ',
      '   qiiiiiiiq    ',
      '   iPPPPPPPiwmm ',
      '   IqqqqqqI     ',
      '  ii    ii      ',
      ' ##    ###      ',
    ],
  ],

  /* 4 (UNIT_ART 19) Ogre — 20x20. Enormous and hunched: a tiny tusked head sunk
     between slab shoulders, a barrel gut, a war-painted loincloth and a
     stone-studded log club. Frame 1 sinks the body a row and hauls the club
     down and forward in a full overhead swing while the legs plant wide. */
  [
    [
      '                    ',
      '               nn   ',
      '      EEEE   nbbbbn ',
      '     EEEEEE  bbbbbb ',
      '     EeeeeeE nbbbbn ',
      '     ekeeekE  bbbb  ',
      '     xeeeeex  bb    ',
      '    EEmeemEE  bb    ',
      ' qqEEEEEEEEqq bb    ',
      ' qePPPPPPPPeq bb    ',
      ' eePPPPPPPPee bb    ',
      ' eePPPPPPPPeeebb    ',
      '  eePPPPPPPPee      ',
      '  EeePPPPPPeeE      ',
      '   qqqqqqqqqq       ',
      '   qqxqqqqxqq       ',
      '   eeee  eeee       ',
      '   Eee    eeE       ',
      '   Eee    eeE       ',
      '  ####    ####      ',
    ],
    [
      '                    ',
      '                    ',
      '                    ',
      '      EEEE          ',
      '     EEEEEE         ',
      '     EeeeeeE   nn   ',
      '     ekeeekE nbbbbn ',
      '     xeeeeex bbbbbb ',
      '    EEmeemEE bbbbbb ',
      ' qqEEEEEEEEqq bbbb  ',
      ' qePPPPPPPPeeebb    ',
      ' eePPPPPPPPee       ',
      '  eePPPPPPPPee      ',
      '  EeePPPPPPeeE      ',
      '   qqqqqqqqqq       ',
      '   qqxqqqqxqq       ',
      '  eeee    eeee      ',
      '  eee      eee      ',
      ' Eee        eeE     ',
      ' ####       ####    ',
    ],
  ],

  /* 5 (UNIT_ART 20) Murloc — 16x16. Amphibian: crest and cheek fins, bulging
     pale eyes over a needle-toothed maw, gill frills at the shoulders, webbed
     splay-feet and a barbed fish spear. Frame 1 flares the fins, tucks the legs
     and lands the body a row lower — a hop rather than a walk. */
  [
    [
      '                ',
      '                ',
      '             m  ',
      '      a  a  dqd ',
      '      aa aa  q  ',
      '    aaaaaaaa q  ',
      '   acaaaaaca q  ',
      '  aakaaaaaka q  ',
      '  aAmmmmmmAa q  ',
      ' AaAaaaaaaAaAq  ',
      '  AaaaaaaaaA q  ',
      '  aPPPPPPPPa q  ',
      '  aPPPPPPPPaaq  ',
      '  AAaaaaaaAA q  ',
      '   aa    aa     ',
      '  AAAA  AAAA    ',
    ],
    [
      '                ',
      '                ',
      '                ',
      '             m  ',
      '     a   a  dqd ',
      '     aa aa   q  ',
      '    aaaaaaaa q  ',
      '   acaaaaaca q  ',
      '  aakaaaaaka q  ',
      '  aAmmmmmmAa q  ',
      ' AaAaaaaaaAaAq  ',
      '  AaaaaaaaaA q  ',
      '  aPPPPPPPPaaq  ',
      '  aPPPPPPPPa    ',
      '  AAaaaaaaAA    ',
      ' AAAA    AAAA   ',
    ],
  ],

  /* 6 (UNIT_ART 21) Wyvern — 32x20. A reptile, and drawn so the silhouette says
     so before the colour does. Two hind legs and no forelimbs. Each wing is a
     single smooth membrane — straight leading edge, sharp point, dark finger
     struts crossing it — swept back into a narrow blade, so the pair reads as a
     V opening to the left. Through the mouth of that V runs a whip tail, one
     pixel thick, the full width of the sprite, to a burning barb at the very
     edge. Head, jaw, belly, tail and talons are fixed palette: on a near-white
     kingdom the beast still has a dark underside and a lit muzzle rather than
     going to slab. Frame 1 is the downstroke — both wings rotate down. */
  [
    [
      '     dPPd                       ',
      '     dPPPPd                     ',
      '      dPPPPPd                   ',
      '      dPPPdPPPd                 ',
      '       dPPPdPPPPd               ',
      '       dPPPPdPPPdPd             ',
      '        dPPPPdPPPdPPd           ',
      '        dPPPPPdPPPdPPd    d d   ',
      '         dPPPPPdPPPdPPd    d d  ',
      '            dPPPPPPPPPPPddqqqqqd',
      '  y         dPPPPPPPPPPPdqqkqqqd',
      'yyyyqqqqqqqqdqqqqqqqqqqqdqqmmyry',
      '  y      dPPPPdPPPdPPdqqqd      ',
      '        dPPPPPdPPPdPPdqq qq     ',
      '        dPPPPdPPPdPPd q   q     ',
      '       dPPPPdPPPdPd   q   q     ',
      '       dpppdppppd    ymy ymy    ',
      '      dpppdpppd                 ',
      '      dpppppd                   ',
      '     dpppd                      ',
    ],
    [
      '                                ',
      '                                ',
      '                                ',
      '        dPPd                    ',
      '        dPPPPd                  ',
      '         dPPPPPd                ',
      '         dPPPdPPPd              ',
      '          dPPPdPPPPd      d d   ',
      '          dPPPPdPPPdPd     d d  ',
      '            dPPPPPPPPPPPddqqqqqd',
      '  y         dPPPPPPPPPPPdqqkqqqd',
      'yyyyqqqqqqqqdqqqqqqqqqqqdqqmmyry',
      '  y      dPPPPdPPPdPPdqqqd      ',
      '       dPPPPPPdPPPdPPdqq qq     ',
      '      dPPPPPPdPPPdPPd q   q     ',
      '     dPPPPPPdPPPdPd   q   q     ',
      '    dpppppdpppppd    ymy ymy    ',
      '   dpppppdppppd                 ',
      '  dppppppppd                    ',
      '  dpppppd                       ',
    ],
  ],

  /* 7 (UNIT_ART 22) Griffin — 32x20. Eagle in front, lion behind, and built as
     the opposite animal to the wyvern rather than the same one repainted. The
     wings are feathered, not membrane: the outer edge drops in two-row steps
     like a comb of primaries, each step capped with a pale quill pixel, and the
     near wing is a broad top-heavy fan while the far wing hangs shorter and
     lower — no symmetry, no points. There is no long tail at all, only a short
     lion tuft off the haunch. Four limbs hang under the barrel — rear paws and
     front talons — and they, not a wing tip, are the lowest thing on the sprite.
     Broad pale skull, hooked gold beak. Frame 1 is the downstroke. */
  [
    [
      '                NPPPPN          ',
      '                NPPPPPN         ',
      '             NPPPNPPPPN         ',
      '             NPPPPPPPPPN        ',
      '           NPPPNPPPPNPPN        ',
      '           NPPPPPPPPPPPN        ',
      '         NPPPNPPPPNPPPPN        ',
      '         NPPPPPPPPPPPPPN        ',
      '        NPPPNPPPPNPPPPPN  NNNNN ',
      '            qqqqqqNNNNNNNNNkNyyy',
      '        b   qqqqqqqNNNNNNNNNNyy ',
      '       bbqqqqqqqqqqqNNNNNNNNNy  ',
      '        b   qqqqqqqqqNNNNN      ',
      '      NPPPNPPPPNPPNqqqqNNN      ',
      '     NPPPPPPPPPPPN qq  NN       ',
      '     NPPPNPPPPNPN  qq  NN       ',
      '      NppppppppN   qq  dd       ',
      '       NpppNppN    qq  dd       ',
      '        NppppN    bqq  ydy      ',
      '                  bbbb ymmy     ',
    ],
    [
      '                                ',
      '                                ',
      '                                ',
      '                 NPPPN          ',
      '               NPPPNPPN         ',
      '               NPPPPPPN         ',
      '            NPPPNPPPPNPN        ',
      '            NPPPPPPPPPPN        ',
      '          NPPPNPPPPNPPPN  NNNNN ',
      '            qqqqqqNNNNNNNNNkNyyy',
      '        b   qqqqqqqNNNNNNNNNNyy ',
      '       bbqqqqqqqqqqqNNNNNNNNNy  ',
      '        b   qqqqqqqqqNNNNN      ',
      '     NPPPNPPPPNPPPNqqqqNNN      ',
      '    NPPPPPPPPPPPPN qq  NN       ',
      '   NPPPNPPPPNPPPN  qq  NN       ',
      '   NpppppppppppN   qq  dd       ',
      '  NpppNppppNppN    qq  dd       ',
      '  NppppppppppN    bqq  ydy      ',
      '   NpppppppN      bbbb ymmy     ',
    ],
  ],
];

/**
 * The merchantman — 20x16, UNIT_ART 23.
 *
 * Deliberately **not** the transport. Where the troop ship is a lean clinker
 * hull with a shield strake along the gunwale and a narrow sail, this is a fat
 * cog: a broad belly with no shields on it at all, a sail twice the width with
 * a gold merchant's band across the middle, and cargo lashed on the open deck —
 * a crate forward, a gold-hooped barrel aft. At a glance across a bay you
 * should be able to say whether what is coming carries soldiers or money,
 * because in this game those are entirely different problems.
 *
 * Frame 1 reverses the billow of the sail (the shading and the band swap rows),
 * flips the masthead pennant to the other side and shortens the wake, so a ship
 * under way visibly works rather than sliding.
 */
export const ART_UNITS_TRADESHIP: string[][] = [
  [
    '         b yy       ',
    '         b          ',
    '   wwwwwwwwwwwwww   ',
    '   PPPPPPbPPPPPPP   ',
    '   PPPPPPbPPPPPPP   ',
    '   yyyyyybyyyyyyy   ',
    '   PPPPPPbPPPPPPP   ',
    '   ppppppbppppppp   ',
    '    pppppbpppppp    ',
    '     wwwwbwwww      ',
    '   qbq   b   wyw    ',
    '  bbbbbbbbbbbbbbbb  ',
    ' bPPPPPPPPPPPPPPPPb ',
    ' bwwwwwwwwwwwwwwwwb ',
    '  bwwwwwwwwwwwwwwb  ',
    '   cccccccccccccc   ',
  ],
  [
    '       yy b         ',
    '         b          ',
    '   wwwwwwwwwwwwww   ',
    '   ppppppbppppppp   ',
    '   PPPPPPbPPPPPPP   ',
    '   PPPPPPbPPPPPPP   ',
    '   yyyyyybyyyyyyy   ',
    '   PPPPPPbPPPPPPP   ',
    '    pppppbpppppp    ',
    '     wwwwbwwww      ',
    '   qbq   b    wyw   ',
    '  bbbbbbbbbbbbbbbb  ',
    ' bPPPPPPPPPPPPPPPPb ',
    ' bwwwwwwwwwwwwwwwwb ',
    '  bwwwwwwwwwwwwwwb  ',
    '    cccccccccccc    ',
  ],
];
